import React from 'react'

export default function UserLoader(props) {

  return (
    <div className={`row col-12 col-lg-7 col-xl-6 m-auto p-0`} style={{zIndex:"1"}}>
        <div className="col col-4 col-xl-4 pt-5 d-none d-lg-block">
            <div className="squeleton mb-4" style={{height:"25px"}}></div>
            <div className="squeleton mb-2 w-50" style={{height:"15px"}}></div>
            <div className="squeleton mb-2 w-75" style={{height:"15px"}}></div>
        </div>
        <div className="col col-12 col-lg-8 col-xl-7 p-0">
            <div className="content text-left col-12 mt-0 mt-lg-4 pt-1 pt-lg-3" style={{zIndex:"2000"}}>
                <div className="container">
                    <div></div>
                    <div className="row form-row d-lg-none mb-4 mt-2">
                        <div className="col col-6">
                            <div className="squeleton" style={{height:"45px"}}></div>
                        </div>
                        <div className="col col-6">
                            <div className="squeleton" style={{height:"45px"}}></div>
                        </div>
                    </div>
                    <div>
                        <form className="mb-5 w-100">
                            <div className="squeleton w-75" style={{height:"35px"}}></div>
                            <div className="mt-4">
                                <div className="squeleton w-25 mb-2" style={{height:"10px"}}></div>
                                <div className="squeleton d-inline-block" style={{height:"55px",width:"55px",marginRight:"2px"}}></div>
                                <div className="squeleton d-inline-block" style={{height:"55px", width:"Calc(100% - 61px)"}}></div>
                            </div>
                            <div className="mt-4">
                                <div className="squeleton w-50 mb-2" style={{height:"10px"}}></div>
                                <div className="squeleton w-100" style={{height:"55px"}}></div>
                            </div>
                            <div className="mt-4">
                                <div className="squeleton mb-2" style={{height:"10px", width:"40%"}}></div>
                                <div className="form-row">
                                    <div className="col">
                                        <div className="squeleton" style={{height:"55px"}}></div>
                                    </div>
                                    <div className="col">
                                        <div className="squeleton" style={{height:"55px"}}></div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 mb-2">
                                <div className="squeleton mb-2" style={{height:"10px", width:"60%"}}></div>
                                <div className="squeleton w-100" style={{height:"55px"}}></div>
                            </div>
                            <div className="squeleton mt-5" style={{height:"55px"}}></div>
                        </form>
                    </div>
                    <div className="squeleton mt-4 mb-2" style={{width:"150px", height:"7px"}}></div>
                </div>
            </div>
        </div>
    </div>
  )
}